module.exports = __webpack_public_path__ + "img/banner2_2x.c0232a52.jpg";